// extracted by mini-css-extract-plugin
module.exports = {"backTop":"backTop--XTFg_","action":"action--3givh","up":"up--3TQMB","cart":"cart--2-Q9v","custom":"custom--2AmmW"};